import StudentClassCard from "./StudentClassCard";

export default StudentClassCard;
